import { RolesItem } from './../Core/Entities/RolesItem'

export const moduleKey = 'purchasing'
export const roles: RolesItem = {
    report: {
        name: 'Relatórios', key: `${moduleKey}:report`, permissions: {
            read: { name: 'Visualizar', description: 'Visualizar indicadores de compras e financeiro', key: `${moduleKey}:report:read` },
        },
    },
    stage: {
        name: 'Estágios', key: `${moduleKey}:stage`, permissions: {
            read: { name: 'Visualizar', description: 'Visualizar configuração dos estágios', key: `${moduleKey}:stage:read` },
            manage: { name: 'Gerenciar', description: 'Criar, editar e ordenar estágios', key: `${moduleKey}:stage:manage` },
        },
    },
    process: {
        name: 'Processos',
        key: `${moduleKey}:process`,
        permissions: {
            read: {
                name: 'Visualizar',
                description: 'Permite visualizar processos de compra',
                key: `${moduleKey}:process:read`,
            },
            create: {
                name: 'Criar',
                description: 'Permite criar processos de compra',
                key: `${moduleKey}:process:create`,
            },
            update: {
                name: 'Editar',
                description: 'Permite editar processos de compra',
                key: `${moduleKey}:process:update`,
            },
            status: {
                name: 'Alterar status',
                description: 'Permite alterar o status do processo',
                key: `${moduleKey}:process:status`,
            },
            stage: {
                name: 'Alterar estágio',
                description: 'Permite alterar o estágio do processo',
                key: `${moduleKey}:process:stage`,
            },
        },
    },
    supplier: {
        name: 'Fornecedores',
        key: `${moduleKey}:supplier`,
        permissions: {
            read: {
                name: 'Visualizar',
                description: 'Permite visualizar fornecedores',
                key: `${moduleKey}:supplier:read`,
            },
            create: {
                name: 'Criar',
                description: 'Permite cadastrar fornecedores',
                key: `${moduleKey}:supplier:create`,
            },
            update: {
                name: 'Editar',
                description: 'Permite editar fornecedores',
                key: `${moduleKey}:supplier:update`,
            },
        },
    },
    purchase: {
        name: 'Compras',
        key: `${moduleKey}:purchase`,
        permissions: {
            read: {
                name: 'Visualizar',
                description: 'Permite visualizar a compra do processo',
                key: `${moduleKey}:purchase:read`,
            },
            create: {
                name: 'Gerar',
                description: 'Permite gerar a compra a partir da cotação vencedora',
                key: `${moduleKey}:purchase:create`,
            },
            update: {
                name: 'Editar',
                description: 'Permite editar campos operacionais da compra',
                key: `${moduleKey}:purchase:update`,
            },
            status: {
                name: 'Alterar status',
                description: 'Permite alterar o status da compra',
                key: `${moduleKey}:purchase:status`,
            },
        },
    },
    payment: {
        name: 'Pagamentos',
        key: `${moduleKey}:payment`,
        permissions: {
            read: { name: 'Visualizar', description: 'Visualizar pagamentos', key: `${moduleKey}:payment:read` },
            create: { name: 'Criar', description: 'Criar pagamentos planejados', key: `${moduleKey}:payment:create` },
            update: { name: 'Editar', description: 'Editar pagamentos pendentes', key: `${moduleKey}:payment:update` },
            pay: { name: 'Dar baixa', description: 'Marcar pagamento como pago', key: `${moduleKey}:payment:pay` },
            cancel: { name: 'Cancelar', description: 'Cancelar pagamento pendente', key: `${moduleKey}:payment:cancel` },
        },
    },
    attachment: {
        name: 'Documentos',
        key: `${moduleKey}:attachment`,
        permissions: {
            read: { name: 'Visualizar', description: 'Visualizar documentos', key: `${moduleKey}:attachment:read` },
            create: { name: 'Anexar', description: 'Anexar documentos', key: `${moduleKey}:attachment:create` },
            update: { name: 'Editar', description: 'Editar metadados do documento', key: `${moduleKey}:attachment:update` },
            delete: { name: 'Remover', description: 'Remover documentos', key: `${moduleKey}:attachment:delete` },
        },
    },
    production: {
        name: 'Produção', key: `${moduleKey}:production`, permissions: {
            read: { name: 'Visualizar', description: 'Visualizar tickets de produção', key: `${moduleKey}:production:read` },
            link: { name: 'Vincular', description: 'Confirmar ou desfazer vínculos manuais', key: `${moduleKey}:production:link` },
            refresh: { name: 'Atualizar', description: 'Atualizar dados de produção pela integração', key: `${moduleKey}:production:refresh` },
        },
    },
    quote: {
        name: 'Cotações',
        key: `${moduleKey}:quote`,
        permissions: {
            read: {
                name: 'Visualizar',
                description: 'Permite visualizar cotações',
                key: `${moduleKey}:quote:read`,
            },
            create: {
                name: 'Criar',
                description: 'Permite criar cotações',
                key: `${moduleKey}:quote:create`,
            },
            update: {
                name: 'Editar',
                description: 'Permite editar cotações',
                key: `${moduleKey}:quote:update`,
            },
            status: {
                name: 'Alterar status',
                description: 'Permite alterar o status de uma cotação',
                key: `${moduleKey}:quote:status`,
            },
            select: {
                name: 'Selecionar',
                description: 'Permite selecionar cotação vencedora',
                key: `${moduleKey}:quote:select`,
            },
        },
    },
}
